import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../data.service';
import { HttpService } from '../core/services/http.service';
import { ToastrTranslateService } from '../core/services/toastr-translate.service';
import { SharedService } from '../core/services/shared-service/shared.service';
import { CommonUtilService } from '../core/services/common-util-service';

@Component({
  selector: 'app-asset-media-home',
  templateUrl: './asset-media-home.component.html',
  styleUrls: ['./asset-media-home.component.scss']
})
export class AssetMediaHomeComponent implements OnInit {
  @Input() mediaAssetId: number= null;
 
showListMediaModal:boolean=false;
destroy: boolean = true;
  filterMediaListSet: any = {
    compName: "media",
    screenName: "media_list",
  };
  mediaListCount: number = 0;
public mask = [/[0-2]/, /[0-3]/, ':', /[0-5]/, /[0-9]/]
blockedPanel: boolean = false;
showAssetModal:boolean = false;
assetList: any = [];
allMediaList:any=[];
selectedAsset: any;
searchText: string;
selectedTabIndex:any=0;
loggedInUserData:any= null;

showMediaModal:boolean=false;
showVaultModal:boolean=false;
showShippingModal:boolean=false;
hiddenColumns:boolean=false;
displayColumns:any
isfilterMediaClicked:boolean =false;

mediaShippingData:[]=[];    
rows = [];
editing={};
totalRows: number = 0;  
currentPage: number = 1; 
value: string;  
isEditing: boolean = false;
filtersObj: any = null;
orderby:any = 'id'
orderkey:any = 'DESC'
offset: number = 1;
size: number = 10;

TotalCount : number =0;
assetId :any = null;

showMediaHomeModal:boolean=false;
selectedMedia :any;
isFromAddMedia :boolean = false;
isVaultOnly:boolean = false;
mediaData:any;

statusOptions = ['Vault', 'In Transit', 'Customer'];
sortBy: string;
sortValue: number = -1;
sortByName: string;
sortValue1: number = -1;
displayMediaVaultModal:boolean=false;
showMediaStep:boolean = true;
 resolutionLabels:any = ['8K', '6K', '5K', '4K', '2K', '1080p', '1080i', '720p', '480p', '360p', '240p', '144p', 'SD', 'HD', 'Full HD', 'Ultra HD', 'Quad HD', 'UHD', 'HDR'];



isMediaModal:boolean= false;
columnsToRestore: any = [
  "Media Title",
  "Umid",
  "Status",
  "SAN Status",
  "Version",
  "Type",
  "Support",
  "Format",
  "Bit Rate",
  "Language",
  "Upload By",
  "Date upload",
  "add shipping",
  "add vault",
  "Container",
  "Resolution",
  "ColorSpace",
  "File Type",
  "File Url",
  "Duration",
  "Aspect Ratio",
  "Frame Rate",
  "Audio",
  "Copy Print"
];
dropdownMediaData: any;
  isfiterClicked: boolean = false;



  constructor(private router:Router,private dataService: DataService,
              private httpService: HttpService,
              private toastr: ToastrTranslateService,
              public sharedService: SharedService,
              private commonUtilService: CommonUtilService,
              private route: ActivatedRoute,
            
            ) { }


  ngOnInit(): void {
    // this.dataService.checkSubmenu(this.router);
    this.isfiterClicked = false;
    if (this.mediaAssetId) {
      this.loadMediaForAsset(this.mediaAssetId);
    }
  
    this.loggedInUserData = this.sharedService.getLoggedInUserData();

     this.filtersObj =
        this.sharedService.filterSelectedObj[this.filterMediaListSet.screenName] ||
        {};

    if(!this.mediaAssetId && this.mediaAssetId ==  null ){
    this.getAllMedia();
  }
    this.getMediaColumn();
    
    this.getMediaDropDownData()
  }

  seletedFilters(event:any){
    this.filtersObj = JSON.parse(event);
    console.log(this.filtersObj);
    this.getAllMedia();

  }
 

  openShippingForm(data : any){
    this.selectedMedia = data;
    this.showShippingModal = true;
    this.isFromAddMedia = true; 
    console.log(data);

  }

     @HostListener("document:click", ["$event.target"])
      onClickedOutside(targetElement) {
        if (!targetElement.closest("#openFIlterMenu") && this.isfiterClicked) {
           this.isfiterClicked = false;
        }
        if (!targetElement.closest("#hidden-columns")) {
          this.hiddenColumns = false;
        }
      }
  

  
    closeModal($event) {
      console.log(event);
      this.showAssetModal = $event
      this.showListMediaModal = $event
      this.showShippingModal= $event;
      this.displayMediaVaultModal= $event;
      this.ngOnInit();
    }

    openAssetModal(){
      this.showAssetModal=!this.showAssetModal;
      this.destroy=false;
    }
  
    openListMediaModal(){
      this.showListMediaModal = !this.showListMediaModal;
      this.destroy=false;
      console.log("opening new media form"+" "+ this.showListMediaModal);
    }

    async getAllMedia(){
      this.blockedPanel=true;
      try{
          let obj: any = {
          offset: this.offset-1,
          size: this.size,
          orderby:this.orderby,
          orderky:this.orderkey,
        
        } 

              let newObjects = {};
        newObjects =
          this.sharedService.filterSelectedObj[
            this.filterMediaListSet.screenName
          ] || {};
        this.mediaListCount = Object.keys(newObjects).length;
      
      const newObjectsArray = Object.keys(newObjects).map((key) => ({
        [key]: newObjects[key],
      }));
      newObjectsArray.forEach((newObj, index) => {
        const [newKey, newValue] = Object.entries(newObj)[0];
        this.filtersObj[newKey] = newValue;
      });

        if (this.filtersObj != null) {
          obj = { ...this.filtersObj };
          delete obj["offset"];
          delete obj["size"];
        }
  
        if(this.assetId != null && this.assetId != undefined){
          obj.assetId = this.assetId;
        }
        const res: any = await this.commonUtilService.getMediaData(obj);
  
        const res1: any = await this.commonUtilService.getMediaByStaffIdCount();
  
        this.allMediaList = res || [];
        console.log(this.allMediaList)
  
        this.TotalCount = res1;
  
  
       this.assetId=null;
       this.blockedPanel=false;
      }
      catch(error){
        this.blockedPanel = false;
        console.log(error);
      }
     
    }

    formatDuration(duration: string): string {
  if (!duration) return '';

  const [hours, minutes] = duration.split(':').map(part => part.trim());

  const h = parseInt(hours, 10);
  const m = parseInt(minutes, 10);

  let result = '';
  if (h) {
    result += `${h} h `;
  }
  if (m) {
    result += `${m} m`;
  }

  return result.trim() || ''; // fallback for "00:00"
}


    async createCol(colName, index) {
      try {
        let obj = {
          id: null,
          columnName: colName,
          columnId: this.displayColumns.length,
          staffId: this.loggedInUserData.id,
        };
        if (index != -1) {
          this.columnsToRestore.splice(index, 1);
        }
        const res: any = await this.commonUtilService.addMediaColumn(obj);
        this.columnsToRestore.sort()
        this.getMediaColumn();
        
  
        this.toastr.success(`${colName} Column restored.`);
      } catch (error) {
        this.toastr.warning(error.error.message);
        
      }
    }

    async getMediaColumn() {
      try {
        this.displayColumns = [];
        const res: any = await this.commonUtilService.getMediaColumn(
          this.loggedInUserData.id
        );
        console.log("this is response", res);
        this.displayColumns = res;
    
        // Mapping of column names to column props
        const columnPropsMap = {

          "Media Title": "mediaTitle",
          "Umid": "uMId",
          "Status": "status",
          "SAN Status": "sanStatus",
           "Version": "mediaVersion",
          "Type": "mediaType",
          "Support": "mediaSupportName",
          "Format": "formatName",
          "Bit Rate": "mediaBitrateId",
          "Language": "language",
          "Upload By": "personId",
          "Date upload": "date",
          "add shipping": "add shipping",
          "Container": "container",
          "Resolution":"resolution",
          "ColorSpace": "colorSpace",
          "File Type": "fileType",
          "File Url": "fileUrl",
          "Duration": "duration",
          "Aspect Ratio" :"aspectRatio",
           "Frame Rate": "frameRate",
           "Audio" : "audio",
           "Copy Print" : "copy print"
         
         
        };

       console.log("this is first ds p", this.displayColumns)
        if (this.displayColumns.length > 0) {
          for (let i = 0; i < this.displayColumns.length; i++) {
            let el = this.displayColumns[i];
            el.name = el.columnName;
            el.prop = columnPropsMap[el.columnName] || el.columnName.toLowerCase(); // Set prop from map or use columnName
            el.index = el.columnId;
            if(i== 0){
            el.width = 300;
            }
            else{
              el.width =200;
            }
            el.sortable = true;
            
            const index = this.columnsToRestore.findIndex(
              (col) => col.toLowerCase() === el.columnName.toLowerCase()
            );
            if (index !== -1) {
              this.columnsToRestore.splice(index, 1);
            }
          }
          this.displayColumns.sort((a, b) => (a.index < b.index ? -1 : 1));
          this.columnsToRestore.sort();
        } else {
          this.createCol("Media Title", 0);
        }
        console.log(this.displayColumns);
      } catch (error) {
        this.toastr.warning(error.error.message);
      }
    }
  
  
    
    getMediaDropDownData(){
      this.httpService.callApi('getMediaDropDownData',{}).subscribe((response) => {
        this.dropdownMediaData = response;
     }, error => {
          this.toastr.warning(error.error.message, 'Asset');
        });
  
  
    }
    updateRowProperty(property: string, value: any, index: number, row: any): void {
      row[property] = value;  // Dynamically update the property
    
      let obj = {
        "id": row.id,
        "assetId": row.assetId,
        "uMId": row.uMId,
        "formatId": row.formatId,
        "formatName": row.formatName,
        "language": row.language,
        "mediaBitrateId": row.mediaBitrateId,
        "mediaSupportId": row.mediaSupportId,
        "mediaTitle": row.mediaTitle,
        "mediaTypeId": row.mediaTypeId,
        "mediaVersion": row.mediaVersion,
        "personId": row.personId,
        "sanStatus": row.sanStatus,
        "status": row.status,
        "container" : row.container,
        "resolution": row.resolution,
        "colorSpace" : row.colorSpace,
        "fileType": row.fileType,
        "fileUrl" :  row.fileUrl,
        "duration" : row.duration,
        "aspectRatio" : row.aspectRatio,
        "frameRate" : row.frameRate,
        "audio" : row.audio,
        "date": row.date,

      };
    
      obj[property] = value;
    
      console.log("this is final object",obj);
      this.updateMediaData(obj);  
      this.rows[index] = row;  
    }
  
    setMediaTitle(value: string, index: number, row: any): void {
      this.updateRowProperty('mediaTitle', value, index, row);  
    }
    
    setLanguageData(value: string, index: number, row: any): void {
      this.updateRowProperty('language', value, index, row); 
    }
    
    setStatus(value: any, index: number, row: any): void {
      this.updateRowProperty('status', value, index, row);  
    }
    
    setSanStatus(value: any, index: number, row: any): void {
      this.updateRowProperty('sanStatus', value, index, row);  
    }
    
    
    setMediaFormat(value: any, index: number, row: any): void {
      row.formatName = value.name;
      this.updateRowProperty('formatId', value.id, index, row); 
    }
    
    setBitRateData(value: any, index: number, row: any): void {
      this.updateRowProperty('mediaBitrateId', value.id, index, row);  
    }
    
    setMediaVersionData(value: any, index: number, row: any): void {
      this.updateRowProperty('mediaVersion', value, index, row); 
    }

          setDateUpload(value: any, index: number, row: any): void {
        this.updateRowProperty('date', value, index, row);
      }


      setContainer(value: any, index: number, row: any): void {
        this.updateRowProperty('container', value, index, row);
      }

      setResolution(value: any, index: number, row: any): void {
        this.updateRowProperty('resolution', value, index, row);
      }

      setColorSpace(value: any, index: number, row: any): void {
        this.updateRowProperty('colorSpace', value, index, row);
      }

      setFileType(value: any, index: number, row: any): void {
        this.updateRowProperty('fileType', value, index, row);
      }

      setFileUrl(value: any, index: number, row: any): void {
        this.updateRowProperty('fileUrl', value, index, row);
      }

      setDuration(value: any, index: number, row: any): void {
        this.updateRowProperty('duration', value, index, row);
      }

      setAspectRatio(value: any, index: number, row: any): void {
        this.updateRowProperty('aspectRatio', value, index, row);
      }

      setFrameRate(value: any, index: number, row: any): void {
        this.updateRowProperty('frameRate', value, index, row);
      }

      setAudio(value: any, index: number, row: any): void {
        this.updateRowProperty('audio', value, index, row);
      }

  
    updateMediaData(obj): void {
      let body = obj;
      console.log(body);
      this.httpService.callApi('saveOrUpdateMedia', { body: body }).subscribe(
        (response) => {
          this.toastr.success('Media file updated')
          console.log("successfully saved data" )
        },
        (error) => {
          this.toastr.warning(error.error.message, 'Media');
        }
      );
    }
    
  
    setMediaTypeListData(value:any, index:number, row:any){
      row.mediaType= value.name;
      let obj ={
        "id": row.id,
        "assetId": row.assetId,
        "uMId":row.uMId,
        "formatId": row.formatId,
        "formatName": row.formatName,
        "language": row.language,
        "mediaBitrateId":row.mediaBitrateId,
        "mediaSupportId": row.mediaSupportId,
        "mediaTitle": row.mediaTitle,
        "mediaTypeId":value.id,
        "mediaVersion": row.mediaVersion,
        "personId":row.personId,
        "sanStatus":row.sanStatus,
        "status": row.status,
        "container" : row.container,
        "resolution": row.resolution,
        "colorSpace" : row.colorSpace,
        "fileType": row.fileType,
        "fileUrl" :  row.fileUrl,
        "duration" : row.duration,
        "aspectRatio" : row.aspectRatio,
        "frameRate" : row.frameRate,
        "audio" : row.audio
      }
      console.log(obj)
      console.log('Updated language:', value); 
      this.updateMediaData(obj);
    }
  
    setMediaSupportData(value:any, index:number, row:any){
      row.mediaSupportName = value.name;
      let obj ={
        "id": row.id,
        "assetId": row.assetId,
        "uMId":row.uMId,
        "formatId": row.formatId,
        "formatName": row.formatName,
        "language": row.language,
        "mediaBitrateId":row.mediaBitrateId,
        "mediaSupportId": value.id,
        "mediaTitle": row.mediaTitle,
        "mediaTypeId":row.mediaTypeId,
        "mediaVersion": row.mediaVersion,
        "personId":row.personId,
        "sanStatus":row.sanStatus,
        "status": row.status,
        "container" : row.container,
        "resolution": row.resolution,
        "colorSpace" : row.colorSpace,
        "fileType": row.fileType,
        "fileUrl" :  row.fileUrl,
        "duration" : row.duration,
        "aspectRatio" : row.aspectRatio,
        "frameRate" : row.frameRate,
        "audio" : row.audio
      }
      console.log(obj)
      console.log('Updated language:', value); 
      this.updateMediaData(obj);
    }
  
    setUploaderData(value:any, index:number, row:any){
      row.personId = value.id;
      let obj ={
        "id": row.id,
        "assetId": row.assetId,
        "uMId":row.uMId,
        "formatId": row.formatId,
        "formatName": row.formatName,
        "language": row.language,
        "mediaBitrateId":row.mediaBitrateId,
        "mediaSupportId": row.mediaSupportId,
        "mediaTitle": row.mediaTitle,
        "mediaTypeId":row.mediaTypeId,
        "mediaVersion": row.mediaVersion,
        "personId":value.id,
        "sanStatus":row.sanStatus,
        "status": row.status,
        "container" : row.container,
        "resolution": row.resolution,
        "colorSpace" : row.colorSpace,
        "fileType": row.fileType,
        "fileUrl" :  row.fileUrl,
        "duration" : row.duration,
        "aspectRatio" : row.aspectRatio,
        "frameRate" : row.frameRate,
        "audio" : row.audio
      }
      console.log(obj)
      console.log('Updated language:', value); 
      this.updateMediaData(obj);
    }
   
    async deleteMediaColumn(colName: any) {
      try {
        console.log(colName)
        console.log(this.displayColumns)
        let index = this.displayColumns.findIndex(
          (el) => el.columnName.toString().toLowerCase() == colName.toLowerCase()
        );
        console.log(index);
        if (index == -1) {
          return;
        }
        this.blockedPanel = true;
  
        const res: any = await this.commonUtilService.deleteMediaColumn(
          this.displayColumns[index].id
        );
        this.getMediaColumn();
        this.columnsToRestore.push(colName);
        this.columnsToRestore.sort();
        this.toastr.success(`${colName} Column removed.`);
        this.blockedPanel = false;
      } catch (error) {
        this.blockedPanel = false;
        console.log(error);
        this.toastr.warning(error.error.message);
        
      }
    }
  
    getBitRateName(bitrateId: any): string {
      const bitRate = this.dropdownMediaData?.mediaBitrateList?.find(rate => rate.id === bitrateId);
      return bitRate ? bitRate.name : '';  
    }
  
    getUserName(personId: any): string {
      const user = this.dropdownMediaData?.staffMemberList?.find(member => member.id === personId);
      return user ? user.fullName : '';  
    }  

    pageChangeListView($event) {
      this.offset = $event;
      this.blockedPanel = true;
      this.getAllMedia();
      }
    

      getStatusClass(status: string): string {
        switch (status) {
          case 'Ingested':
            return 'status-ingested';
          case 'Not Available':
            return 'status-not-available';
          default:
            return 'status-default';
        }
      }

      sort(sortBy: string) {
        if (this.sortBy != sortBy) {
          this.sortValue = -1;
        }
        this.sortBy = sortBy;
        this.sortValue *= -1;
      }
    
      sortList(sortByName: string) {
        if (this.sortByName != sortByName) {
          this.sortValue1 = -1;
        }
        this.sortByName = sortByName;
        this.sortValue1 *= -1;
      }
      
      openMediaVaultForm(data:any){
        console.log(data);
        this.mediaData = data || {};
        this.displayMediaVaultModal=true;
        this.showMediaStep = false;

      }
  

     async  loadMediaForAsset(assetId){
      this.blockedPanel = true;
      console.log(assetId);
       try{
      
        let id = assetId;
        const resp = await this.commonUtilService.getMediaListByAssetId(id);
        console.log(resp);
        this.allMediaList = resp || [];
        this.blockedPanel= false

       }
       catch(error){
        this.blockedPanel=false;
        console.log(error);
       }
      }
  
onDurationInput(value: string): void {
  const arr = value.split(':');
  const str = arr[0] || '';
  const subStr = str.charAt(0);

  if (subStr === '2') {
    this.mask = [/[0-2]/, /[0-3]/, ':', /[0-5]/, /[0-9]/]; // 00–23
  } else {
    this.mask = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/]; // 00–29 fallback
  }
}

}
